import React, { useContext, useEffect, useState } from 'react'
import { firestore } from '../../../firebase';
import StateContext from '../../../StateContext';

function QuizHighscore({quizId}) {

    const appState = useContext(StateContext)

    const [scores, setScores] = useState([]);

    useEffect(() => {

        try {
            const scoreRef = firestore.collection("quiz").doc(quizId).collection("answers");

            scoreRef.orderBy("percentage", "desc").onSnapshot(({docs}) => {
                const scores = docs.map(doc => {
                    return {id: doc.id, ...doc.data()};
                });
                setScores(scores);
            })

        } catch (error) {
            
        }

    }, [quizId])

    function formatNumber(number) {

        return number.toFixed();

    }

    async function deleteHandler(e, scoreId) {
        e.preventDefault();
        try {
            const scoreRef = firestore.collection("quiz").doc(quizId).collection("answers").doc(scoreId);
            scoreRef.delete();
        } catch (error) {
            
        }
    }

    return (
        <div>
            {scores && scores.length ? (
                <table>
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Navn</th>
                            <th>Poeng</th>
                            <th>%</th>
                        </tr>
                    </thead>
                    <tbody>
                        {scores?.map((score, index) => {
                            return (
                                <tr key={index}>
                                    <td>{index+1} </td>
                                    <td>{score.name}</td>
                                    <td>{score.score}</td>
                                    <td>{formatNumber(score.percentage)} {score.user === appState.userId && <span onClick={(e) => deleteHandler(e, score.id)} className="float-right"><i className="fas fa-trash text-danger"></i></span>}</td>
                                </tr>
                            )
                        })}

                    </tbody>
                </table>
            ) : <p className="text-center">Ingen resultater enda</p>}

        </div>
    )

}
export default QuizHighscore